module.exports = __webpack_public_path__ + "img/pepper-crop-61720.5d79ad2f.jpg";